import {
    Info,
    IconsWrapper,
    FacebookIcon,
    InstagramIcon,
    AddressSection,
    AddressHeader,
    AddressInfo,
    AddressSubHeader,
    LinkWrapper,
    AddressLink,
    AddressContentWrapper,
    MapContainer,
    PhoneIcon,
    MailIcon,
    PinIcon,
    TourIcon,
} from "./styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { LINKS } from "../../../config/links";
import { useTranslation } from "react-i18next";

const Address = () => {
    const { t } = useTranslation("address");

    return (
        <AddressSection id="address">
            <StaggeredContainer>
                <StaggeredItem>
                    <AddressHeader>{t("header")}</AddressHeader>
                </StaggeredItem>

                <StaggeredItem>
                    <AddressContentWrapper>
                        <AddressInfo>
                            <AddressSubHeader>{t("sections.contact")}</AddressSubHeader>

                            <Info>
                                {t("contactInfo.company")}
                                <br />
                                {t("contactInfo.nipLabel")}: {t("contactInfo.nipValue")}
                                <br />
                                {t("contactInfo.street")}
                                <br />
                                {t("contactInfo.city")}
                                <br />
                            </Info>

                            <LinkWrapper>
                                <AddressLink href={LINKS.phone} title={t("labels.phoneTitle")}>
                                    <PhoneIcon /> {t("contactInfo.phoneDisplay")}
                                </AddressLink>
                            </LinkWrapper>

                            <LinkWrapper>
                                <AddressLink href={LINKS.email} title={t("labels.emailTitle")}>
                                    <MailIcon />
                                    {t("contactInfo.emailDisplay")}
                                </AddressLink>
                            </LinkWrapper>

                            <IconsWrapper>
                                <a
                                    href={LINKS.facebook}
                                    target="_blank"
                                    title={t("labels.facebookTitle")}
                                    aria-label={t("labels.facebookTitle")}
                                    rel="noreferrer"
                                >
                                    <FacebookIcon />
                                </a>

                                <a
                                    href={LINKS.instagram}
                                    target="_blank"
                                    title={t("labels.instagramTitle")}
                                    aria-label={t("labels.instagramTitle")}
                                    rel="noreferrer"
                                >
                                    <InstagramIcon />
                                </a>
                            </IconsWrapper>
                        </AddressInfo>

                        <AddressInfo>
                            <AddressSubHeader>{t("sections.czorsztyn")}</AddressSubHeader>

                            <Info>
                                {t("locations.czorsztyn.name")}
                                <br />
                                {t("locations.czorsztyn.street")}
                                <br />
                                {t("locations.czorsztyn.city")}
                                <br />
                            </Info>

                            <LinkWrapper>
                                <AddressLink
                                    href={LINKS.mapsCzorsztyn}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={t("labels.mapsTitle")}
                                >
                                    <PinIcon />
                                    {t("actions.navigateGoogleMaps")}
                                </AddressLink>
                            </LinkWrapper>

                            <LinkWrapper>
                                <AddressLink
                                    href={LINKS.tourCzorsztyn}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={t("labels.tourCzorsztynTitle")}
                                >
                                    <TourIcon />
                                    {t("actions.virtualTourCzorsztyn")}
                                </AddressLink>
                            </LinkWrapper>
                        </AddressInfo>

                        <AddressInfo>
                            <AddressSubHeader>{t("sections.niedzica")}</AddressSubHeader>

                            <Info>
                                {t("locations.niedzica.name")}
                                <br />
                                {t("locations.niedzica.street")}
                                <br />
                                {t("locations.niedzica.city")}
                                <br />
                            </Info>

                            <LinkWrapper>
                                <AddressLink
                                    href={LINKS.mapsNiedzica}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={t("labels.mapsTitle")}
                                >
                                    <PinIcon />
                                    {t("actions.navigateGoogleMaps")}
                                </AddressLink>
                            </LinkWrapper>

                            <LinkWrapper>
                                <AddressLink
                                    href={LINKS.tourNiedzica}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={t("labels.tourNiedzicaTitle")}
                                >
                                    <TourIcon />
                                    {t("actions.virtualTourNiedzica")}
                                </AddressLink>
                            </LinkWrapper>
                        </AddressInfo>
                    </AddressContentWrapper>
                </StaggeredItem>
            </StaggeredContainer>

            <StaggeredContainer>
                <StaggeredItem>
                    <MapContainer>
                        <iframe
                            title={t("mapFrameTitle")}
                            src={LINKS.googleMapFrame}
                            width="640"
                            height="480"
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </MapContainer>
                </StaggeredItem>
            </StaggeredContainer>
        </AddressSection>
    );
};

export default Address;